import type { CatalogVoice, VoiceCatalogValue } from "./contracts";

export const VOICE_CATALOG_KEY = "audio.voice_catalog.v1";

export function buildVoiceCatalogDraftValues(
  activeValues: Record<string, unknown>,
  candidate: CatalogVoice,
): Record<string, unknown> {
  const activeCatalog = activeValues[VOICE_CATALOG_KEY] as
    | VoiceCatalogValue
    | undefined;
  const voices = [...(activeCatalog?.voices ?? [])];
  if (voices.some((voice) => voice.voice_id === candidate.voice_id)) {
    throw new Error("This voice is already in the active catalog.");
  }
  return {
    ...activeValues,
    [VOICE_CATALOG_KEY]: {
      schema_version: "voice_catalog.v1",
      voices: [
        ...voices,
        {
          ...candidate,
          enabled: true,
          product_flows: ["b2c"],
        },
      ],
    } satisfies VoiceCatalogValue,
  };
}

export function buildDisabledVoiceCatalogDraftValues(
  activeValues: Record<string, unknown>,
  voiceId: string,
): Record<string, unknown> {
  return buildVoiceEnabledDraftValues(activeValues, voiceId, false);
}

export function buildEnabledVoiceCatalogDraftValues(
  activeValues: Record<string, unknown>,
  voiceId: string,
): Record<string, unknown> {
  return buildVoiceEnabledDraftValues(activeValues, voiceId, true);
}

function buildVoiceEnabledDraftValues(
  activeValues: Record<string, unknown>,
  voiceId: string,
  enabled: boolean,
): Record<string, unknown> {
  const activeCatalog = activeValues[VOICE_CATALOG_KEY] as
    | VoiceCatalogValue
    | undefined;
  if (!activeCatalog) {
    throw new Error("The active voice catalog is unavailable.");
  }
  const target = activeCatalog.voices.find(
    (voice) => voice.voice_id === voiceId,
  );
  if (!target) {
    throw new Error("This voice is not in the active catalog.");
  }
  if (target.enabled === enabled) {
    throw new Error(
      enabled
        ? "This voice is already turned on."
        : "This voice is already turned off.",
    );
  }
  return {
    ...activeValues,
    [VOICE_CATALOG_KEY]: {
      ...activeCatalog,
      voices: activeCatalog.voices.map((voice) =>
        voice.voice_id === voiceId ? { ...voice, enabled } : voice,
      ),
    } satisfies VoiceCatalogValue,
  };
}
